export class UrlConstant {
  public static readonly LOGIN = '/oauth/token';
  public static readonly LOGOUT = '/login/logout';
  public static readonly VALIDATE = '/login/validate';
  public static readonly VALIDATE_ADMIN = '/login/validateadmin';
  public static readonly VALIDATE_CSC = '/login/validatecsc';

  public static readonly LIST_USER = '/User';
  public static readonly DELETE_USER = '/users/delete/';
  public static readonly ADD_USER = '/users';
  public static readonly DETAIL_USER = '/users';
  public static readonly UPDATE_USER = '/users/update';
  public static readonly LIST_ROLE = '/role';
  public static readonly LIST_GROUP = '/group';
  public static readonly LIST_ACTION = '/action';
  public static readonly LIST_MENU = '/menu';
  public static readonly LIST_STAFF = '/staff';
  public static readonly LIST_WORKROLE = '/workRole';
  public static readonly LIST_ORDER = '/orders';
  public static readonly URL_REQUEST = '/request';
  public static readonly URL_PROFILE = '/profile';
  public static readonly URL_ORDER = '/orders';
  public static readonly URL_REPORT = '/api';
  public static readonly URL_COUNTRY = '/diccountries';
  public static readonly URL_DEST_CITY = '/dicdestcities';
  public static readonly URL_DISCOUNT_PROGRAM = '/discountprograms';
  public static readonly URL_INDIVIDUAL_DISCOUNT = '/individualdiscounts';
  public static readonly URL_PROVINCE = '/dicprovinces';
  public static readonly URL_HSCODE = '/dichscodes';
  public static readonly URL_PAYMENT = '/payment';
  public static readonly SEND_SPECIMEN = '/SendSpecimen';

  /*Dinh duong*/
  public static readonly LIST_PHONG = '/department';
  public static readonly LIST_LOAIMON = '/loaimon';
  public static readonly LIST_TAIKHOAN = '/user';
  public static readonly LIST_CUSTOMER = '/customer';
  public static readonly LIST_PARTNER = '/partner';
  public static readonly LIST_MONAN = '/monan';
  public static readonly UPLOAD = '/file/upload';
  public static readonly LIST_DONHANG = '/donHang';
  public static readonly LIST_NHOMTAIKHOAN = '/group';
  public static readonly LIST_PARTNERS = '/Partners';
  public static readonly LIST_SALESMAN = '/SalesMan';
  public static readonly LIST_ACCOUNTP = '/User';
  public static readonly LIST_SPECIMENTYPE = '/specimentype';
  public static readonly LIST_SPECIMEN = '/specimen';
  public static readonly LIST_TASK = '/tasks';
  public static readonly LIST_PATIENT = '/patients';
  public static readonly LIST_ORDERTYPEPROFILE = '/OrderTypeProfile';
  public static readonly LIST_ORDERGROUP = '/OrderTypeGroup';
  public static readonly LIST_SPECIALTY = '/api/Specialty';

  public static readonly LIST_MACHINETYPE = '/MachineType';
  public static readonly URL_LABORATORY = 'Laboratory';
  public static readonly LIST_BARCODE_TEMPLATE = '/BarcodeConfigs';
  public static readonly LIST_ORDERTYPE = '/OrderType';
  public static readonly LIST_MACHINE = '/Machine';
  public static readonly LIST_TASKTYPE = '/TaskType';
  public static readonly LIST_RESULTTYPE = '/ResultTypes';
  public static readonly LIST_TEST_RESULT = '/ResultValues';
  public static readonly LIST_KHO = '/warehouse';
  public static readonly LIST_DMTHIETBI = '/dmdevice';
  public static readonly LIST_THIETBI = '/device';
  public static readonly LIST_DM_HANGHOA = '/dmgoods';
  public static readonly LIST_HANGHOA = '/goods';
  public static readonly LIST_MINETURNS = '/mineturns';
  public static readonly LIST_TURNSSTATUS = '/turnsStatus';
  public static readonly LIST_TONKHO = '/warehouseGoods';

  public static readonly LIST_PHIEU_NHAPKHO = '/warehouseImport';
  public static readonly LIST_PHIEU_XUATKHO = '/warehouseExport';

  public static readonly LIST_MINETURNSSTAFF = '/mineturnsstaffs';
  public static readonly LIST_WAREHOUSE_FIRST_IMPORT = '/warehousefirstimport';

  public static readonly FILE = '/file';
  public static readonly LIST_CALAMVIEC = '/workshift';
  public static readonly LIST_VAITRO = '/workrole';
  public static readonly LIST_BANNER = '/banners';

  public static readonly LIST_ACCOUNT = '/accounts';
  // ChemicalCategories
  public static readonly LIST_CHEMICAL_CATEGORY = '/ChemicalCategories';
  public static readonly LIST_CATEGORY = '/Categories';
  public static readonly LIST_CHEMICAL = '/Chemicals';
  public static readonly LIST_CONSUMABLE_RATE = '/ConsumableRates';

  public static readonly LIST_INPUT_WAREHOUSE = '/InputWarehouses';
  public static readonly LIST_WAREHOUSE = '/Warehouse';

  public static readonly LIST_MACHINE_RESULT_TYPE = '/MachineResultType';

  public static readonly LIST_WAREHOUSE_EXPORT = '/WarehouseExports';
  public static readonly RE_INPUT_WAREHOUSE = '/ReInputWarehouse';

  // Suppliers
  public static readonly SUPPLIERS = '/Suppliers';

  // Manufacturers
  public static readonly MANUFACTURERS = '/Manufacturers';

  // Consumable-Units
  public static readonly CONSUMABLE_UNITS = '/ConsumableUnits';

  // Warehouse-inventory
  public static readonly WAREHOUSE_INVENTORY = '/ConsumableUnits';

  // Move from machine to machine
  public static readonly MOVE_MACHINE = '/MoveFromMachineToMachine';

  // Print-configs
  public static readonly PRINT_CONFIG = '/PrintConfigs';

  // Calibrate
  public static readonly CALIBRATE = '/Calibrates';

  // Quality-controls
  public static readonly QUALITY_CONTROLS = '/QualityControls';

  // Machine Order Type
  public static readonly LIST_MACHINE_ORDER_TYPE = '/MachineOrderTypes';

  //System config
  public static readonly SYSTEM_CONFIG = '/SysConfig';

  //Normal range
  public static readonly NORMAL_RANGE = '/NormalRange';

  //Billing
  public static readonly BILLING = '/Billing';

  //Appointment Time
  public static readonly APPOINTMENT_TIME = '/AppointmentTime';

  //Report
  public static readonly REPORT = '/Report';

  //Notification
  public static readonly USER_NOTIFICATION = '/UserNotification';
}
